"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const token = {
  fontSize: {
    tiny: {
      value: '10px'
    },
    small: {
      value: '12px'
    },
    medium: {
      value: '14px'
    },
    large: {
      value: '16px'
    },
    xl: {
      value: '18px'
    },
    xxl: {
      value: '20px'
    },
    xxxl: {
      value: '24px'
    },
    base: {
      value: '14px'
    }
  },
  size: {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl'
  },
  imageSize: {
    XXXS: 'xxxs',
    XXS: 'xxs',
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    XXL: 'xxl',
    XXXL: 'xxxl'
  },
  color: {
    DEFAULT: '#3A3D4A',
    PRIMARY: '#27ADFF',
    DANGER: '#FF7D7A',
    BRAND: '#FFC145',
    WHITE: '#FFFFFF'
  }
};
var _default = token;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jcmF0ZXIvdG9rZW4vanMvaW5kZXguanMiXSwibmFtZXMiOlsidG9rZW4iLCJmb250U2l6ZSIsInRpbnkiLCJ2YWx1ZSIsInNtYWxsIiwibWVkaXVtIiwibGFyZ2UiLCJ4bCIsInh4bCIsInh4eGwiLCJiYXNlIiwic2l6ZSIsIlhTIiwiU00iLCJNRCIsIkxHIiwiWEwiLCJpbWFnZVNpemUiLCJYWFhTIiwiWFhTIiwiWFhMIiwiWFhYTCIsImNvbG9yIiwiREVGQVVMVCIsIlBSSU1BUlkiLCJEQU5HRVIiLCJCUkFORCIsIldISVRFIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxNQUFNQSxLQUFLLEdBQUc7QUFDWkMsRUFBQUEsUUFBUSxFQUFFO0FBQ1JDLElBQUFBLElBQUksRUFBRTtBQUFFQyxNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQURFO0FBRVJDLElBQUFBLEtBQUssRUFBRTtBQUFFRCxNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQUZDO0FBR1JFLElBQUFBLE1BQU0sRUFBRTtBQUFFRixNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQUhBO0FBSVJHLElBQUFBLEtBQUssRUFBRTtBQUFFSCxNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQUpDO0FBS1JJLElBQUFBLEVBQUUsRUFBRTtBQUFFSixNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQUxJO0FBTVJLLElBQUFBLEdBQUcsRUFBRTtBQUFFTCxNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQU5HO0FBT1JNLElBQUFBLElBQUksRUFBRTtBQUFFTixNQUFBQSxLQUFLLEVBQUU7QUFBVCxLQVBFO0FBUVJPLElBQUFBLElBQUksRUFBRTtBQUFFUCxNQUFBQSxLQUFLLEVBQUU7QUFBVDtBQVJFLEdBREU7QUFXWlEsRUFBQUEsSUFBSSxFQUFFO0FBQ0pDLElBQUFBLEVBQUUsRUFBRSxJQURBO0FBRUpDLElBQUFBLEVBQUUsRUFBRSxJQUZBO0FBR0pDLElBQUFBLEVBQUUsRUFBRSxJQUhBO0FBSUpDLElBQUFBLEVBQUUsRUFBRSxJQUpBO0FBS0pDLElBQUFBLEVBQUUsRUFBRTtBQUxBLEdBWE07QUFrQlpDLEVBQUFBLFNBQVMsRUFBRTtBQUNUQyxJQUFBQSxJQUFJLEVBQUUsTUFERztBQUVUQyxJQUFBQSxHQUFHLEVBQUUsS0FGSTtBQUdUUCxJQUFBQSxFQUFFLEVBQUUsSUFISztBQUlUQyxJQUFBQSxFQUFFLEVBQUUsSUFKSztBQUtUQyxJQUFBQSxFQUFFLEVBQUUsSUFMSztBQU1UQyxJQUFBQSxFQUFFLEVBQUUsSUFOSztBQU9UQyxJQUFBQSxFQUFFLEVBQUUsSUFQSztBQVFUSSxJQUFBQSxHQUFHLEVBQUUsS0FSSTtBQVNUQyxJQUFBQSxJQUFJLEVBQUU7QUFURyxHQWxCQztBQTZCWkMsRUFBQUEsS0FBSyxFQUFFO0FBQ0xDLElBQUFBLE9BQU8sRUFBRSxTQURKO0FBRUxDLElBQUFBLE9BQU8sRUFBRSxTQUZKO0FBR0xDLElBQUFBLE1BQU0sRUFBRSxTQUhIO0FBSUxDLElBQUFBLEtBQUssRUFBRSxTQUpGO0FBS0xDLElBQUFBLEtBQUssRUFBRTtBQUxGO0FBN0JLLENBQWQ7ZUFzQ2UzQixLIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgdG9rZW4gPSB7XG4gIGZvbnRTaXplOiB7XG4gICAgdGlueTogeyB2YWx1ZTogJzEwcHgnIH0sXG4gICAgc21hbGw6IHsgdmFsdWU6ICcxMnB4JyB9LFxuICAgIG1lZGl1bTogeyB2YWx1ZTogJzE0cHgnIH0sXG4gICAgbGFyZ2U6IHsgdmFsdWU6ICcxNnB4JyB9LFxuICAgIHhsOiB7IHZhbHVlOiAnMThweCcgfSxcbiAgICB4eGw6IHsgdmFsdWU6ICcyMHB4JyB9LFxuICAgIHh4eGw6IHsgdmFsdWU6ICcyNHB4JyB9LFxuICAgIGJhc2U6IHsgdmFsdWU6ICcxNHB4JyB9LFxuICB9LFxuICBzaXplOiB7XG4gICAgWFM6ICd4cycsXG4gICAgU006ICdzbScsXG4gICAgTUQ6ICdtZCcsXG4gICAgTEc6ICdsZycsXG4gICAgWEw6ICd4bCcsXG4gIH0sXG4gIGltYWdlU2l6ZToge1xuICAgIFhYWFM6ICd4eHhzJyxcbiAgICBYWFM6ICd4eHMnLFxuICAgIFhTOiAneHMnLFxuICAgIFNNOiAnc20nLFxuICAgIE1EOiAnbWQnLFxuICAgIExHOiAnbGcnLFxuICAgIFhMOiAneGwnLFxuICAgIFhYTDogJ3h4bCcsXG4gICAgWFhYTDogJ3h4eGwnLFxuICB9LFxuICBjb2xvcjoge1xuICAgIERFRkFVTFQ6ICcjM0EzRDRBJyxcbiAgICBQUklNQVJZOiAnIzI3QURGRicsXG4gICAgREFOR0VSOiAnI0ZGN0Q3QScsXG4gICAgQlJBTkQ6ICcjRkZDMTQ1JyxcbiAgICBXSElURTogJyNGRkZGRkYnLFxuICB9LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgdG9rZW47XG4iXX0=